import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-exit-dialog',
  templateUrl: './confirm-exit-dialog.component.html',
  styleUrls: ['./confirm-exit-dialog.component.scss']
})
export class ConfirmExitDialogComponent {
  constructor(private dialogRef: MatDialogRef<ConfirmExitDialogComponent>) {}

  salirSinGuardar() {
    this.dialogRef.close('exit');
  }

  guardar() {
    this.dialogRef.close('save');
  }
}
